export default class ProductFamilyDao {
    public static tiHost: string = '';
    public static searchApiUrl: string = '/search/productFamily';

    public static async searchProductFamily(familyName: string, locale: string, searchApiUrl?: string, tiHost?: string): Promise<string> {
        ProductFamilyDao.tiHost = tiHost ? tiHost : '';
        ProductFamilyDao.searchApiUrl = searchApiUrl ? searchApiUrl : ProductFamilyDao.searchApiUrl;
        const familyUrl: string = await ProductFamilyDao.fetchProductFamilyUrl(familyName, locale);
        return familyUrl;
    }

    public static async fetchProductFamilyUrl(familyName: string, locale: string): Promise<string> {
        familyName = familyName.replace(/&/g, '&amp;').replace(/"/g, '&quot;')
            .replace(/</g, '&lt;').replace(/>/g, '&gt;');
        familyName = encodeURIComponent(familyName);
        const url = `${ProductFamilyDao.tiHost}${ProductFamilyDao.searchApiUrl}?familyName=${familyName}&locale=${locale}`;
        const response = await fetch(url);
        if (!response.ok) {
            return null;
        }
        let familyUrl = await response.text();
        return familyUrl;
    }
}
